import Chip from '@components/Chip';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { TransactionFilterType } from '@models/prepaidCard';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    filter: TransactionFilterType;
    onChangeFilter: (filter: TransactionFilterType) => void;
}

const FILTERS: TransactionFilterType[] = ['ALL', 'DEDUCTION', 'CHARGE'];

function FilterBar({ filter, onChangeFilter }: Props) {
    const { t } = useTranslation('prepaidCard');
    const from = dayjs().subtract(6, 'month').format('YY.MM.DD');
    const to = dayjs().format('YY.MM.DD');

    return (
        <Container>
            <Text size='body-short' fontWeight='regular' color={colors.textSecondary}>
                {t('log.periodLabel', { from, to })}
            </Text>
            <Chip.Container>
                {FILTERS.map((item) => (
                    <Chip key={item}
                        isSelected={filter === item}
                        aria-label={t(`log.filter.${item}`)}
                        onClick={() => onChangeFilter(item)}>
                        {t(`log.filter.${item}`)}
                    </Chip>
                ))}
            </Chip.Container>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export default FilterBar;
